var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21591 4.96023C5.21591 5.10144 5.10144 5.21591 4.96023 5.21591L1.89205 5.21591C1.46842 5.21591 1.125 5.55933 1.125 5.98295C1.125 6.40658 1.46842 6.75 1.89205 6.75L4.96023 6.75C5.94869 6.75 6.75 5.94869 6.75 4.96023L6.75 1.89205C6.75 1.46842 6.40658 1.125 5.98295 1.125C5.55933 1.125 5.21591 1.46842 5.21591 1.89205L5.21591 4.96023Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0398 5.21591C12.8986 5.21591 12.7841 5.10144 12.7841 4.96023L12.7841 1.89205C12.7841 1.46842 12.4407 1.125 12.017 1.125C11.5934 1.125 11.25 1.46842 11.25 1.89205L11.25 4.96023C11.25 5.94869 12.0513 6.75 13.0398 6.75L16.108 6.75C16.5316 6.75 16.875 6.40658 16.875 5.98295C16.875 5.55933 16.5316 5.21591 16.108 5.21591L13.0398 5.21591Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7841 13.0398C12.7841 12.8986 12.8986 12.7841 13.0398 12.7841H16.108C16.5316 12.7841 16.875 12.4407 16.875 12.017C16.875 11.5934 16.5316 11.25 16.108 11.25H13.0398C12.0513 11.25 11.25 12.0513 11.25 13.0398V16.108C11.25 16.5316 11.5934 16.875 12.017 16.875C12.4407 16.875 12.7841 16.5316 12.7841 16.108V13.0398Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96023 12.7841C5.10144 12.7841 5.21591 12.8986 5.21591 13.0398L5.21591 16.108C5.21591 16.5316 5.55933 16.875 5.98295 16.875C6.40658 16.875 6.75 16.5316 6.75 16.108L6.75 13.0398C6.75 12.0513 5.94869 11.25 4.96023 11.25L1.89205 11.25C1.46842 11.25 1.125 11.5934 1.125 12.017C1.125 12.4407 1.46842 12.7841 1.89205 12.7841L4.96023 12.7841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen2);
export default __webpack_public_path__ + "static/media/fullscreen_2.cfd7bac5a368a8b9d67859f04435c241.svg";
export { ForwardRef as ReactComponent };